import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IPersonalAccessToken } from '../types/IPersonalAccessToken';

export interface GetPersonalAccessTokenClientIdsParams {
  userId: string;
}

export interface GetPersonalAccessTokenClientIdsResult  extends IResult {
  tokenInfos: IPersonalAccessToken[];
}

export class GetPersonalAccessTokenClientIdsRequest extends Request<GetPersonalAccessTokenClientIdsParams, GetPersonalAccessTokenClientIdsResult> {
  constructor(params: GetPersonalAccessTokenClientIdsParams) {
    super('getPersonalAccessTokenNames', params);
  }
}
